import { Flex } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import { ReportFilterTab } from 'shared/types/graphql';

interface BaseFilterTabProps {
  tab: ReportFilterTab | 'Spacer';
}

interface InteractiveFilterTabProps extends BaseFilterTabProps {
  selectedFilterTab: ReportFilterTab;
  setSelectedFilterTab: (selectedTab: ReportFilterTab) => void;
  rightIcon?: JSX.Element;
}

interface SpacerFilterTabProps extends BaseFilterTabProps {
  selectedFilterTab?: never;
  setSelectedFilterTab?: never;
  rightIcon?: never;
}

type FilterTabProps = InteractiveFilterTabProps | SpacerFilterTabProps;

export const FilterTab = ({ tab, selectedFilterTab, setSelectedFilterTab, rightIcon }: FilterTabProps): JSX.Element => {
  const isSpacer = tab === 'Spacer';
  return (
    <Flex
      data-testid={`${tab}-report-tab`}
      alignItems="center"
      pb={2}
      mt={4}
      mr={4}
      onClick={(): void => {
        if (setSelectedFilterTab && tab !== 'Spacer') {
          setSelectedFilterTab(tab);
        }
      }}
      {...(selectedFilterTab === tab && {
        borderBottom: '3px solid',
        borderColor: 'border.success',
      })}
    >
      <Text
        as="p"
        size="sm"
        {...(!isSpacer && { cursor: 'pointer' })}
        variant={selectedFilterTab === tab ? 'success' : 'subtle'}
      >
        {isSpacer ? '|' : tab}
      </Text>
      {!!rightIcon && <Flex ml={1}>{rightIcon}</Flex>}
    </Flex>
  );
};
